export default {
  GET_FOLDER_LIST: state => state.foldersList,
  GET_ONE_FOLDER: state => state.one_folder,
  GET_MAIN_WINDOW: state => state.main_window,
}
